import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Home() {
  return (
    <Box
      sx={{
        height: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: "linear-gradient(45deg, #5c2d91 30%, #FFFFFF 90%)",
        color: "white",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          component="h1"
          sx={{ mb: 4, fontWeight: "bold" }}
        >
          Welcome to IntelliSmart
        </Typography>
        <Typography variant="h5" sx={{ mb: 4 }}>
          Delivers privacy-first, data-driven solutions that transform customer
          engagement into measurable results, ensuring smarter marketing and
          deeper connections.
        </Typography>
        <Box sx={{ "& > *": { mr: 2 } }}>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            component={RouterLink}
            to="/register"
            sx={{ mr: 2 }}  // Added space between buttons
          >
            Get Started
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            component={RouterLink}
            to="/login"
          >
            Login
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Home;
